<template>
  <v-layout>
    <v-flex v-if="products && products.length > 0">
      <!-- <v-card-title class="align-center justify-center mt-1 pb-1 pt-1 mb-1">{{$t('products')}}</v-card-title> -->
      <div class="text-center">
        <small>{{$t('selectUsedProducts')}}</small>
      </div>
      <div class="scroll-container" style="scroll-snap-type: x mandatory;">
        <div v-for="(n,i) in products" :key="'p-'+i" class="text-truncate">
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-layout class="pa-2" @click="select(n.id)" v-on="on" column>
                <v-img
                  gradient="to bottom, rgba(0,0,0,.1), rgba(255,255,255,.5)"
                  aspect-ratio="1"
                  width="142"
                  :src="n.image ? `${n.image}`: emptyImage"
                  dark
                >
                  <v-card-actions class="fill-height align-end gradient">
                    <span class="text-truncate d-inline-block">{{n.name}}</span>
                    <v-spacer></v-spacer>
                    <v-icon color="primary">{{n.selected ? "check_box" : "check_box_outline_blank"}}</v-icon>
                  </v-card-actions>
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-layout>
            </template>
            <span>{{n.name}}</span>
          </v-tooltip>
        </div>
      </div>
    </v-flex>
    <v-flex v-else-if="empty">
      <div class="subtitle mx-auto text-center">{{$t('noproducts')}}</div>
    </v-flex>
    <v-flex v-else-if="productSolutionId">
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  name: "Products",
  props: {
    readonly: Boolean,
    productSolutionId: null,
    selectedProducts: null
  },
  watch: {
    productSolutionId: function() {
      this.products = [];
      this.getProducts(true);
    },
    products() {}
  },
  data() {
    return {
      products: [],
      empty: false,
      emptyImage: require("@/assets/empty.png")
    };
  },
  methods: {
    getProducts() {
      this.empty = false;
      if (this.productSolutionId) {
        this.$http
          .getProductsBySolutionId(this.productSolutionId, true)
          .then(res => {
            this.products = res.data;
            if (res.data.length == 0) this.empty = true;
            else this.empty = false;

            this.products.forEach(p => {
              if (this.selectedProducts) {
                this.selectedProducts.forEach(s => {
                  if (p.id == s.productId) {
                    p.selected = true;
                  }
                });
              }
            });
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    nameFormat(name) {
      if (name.length > 10) return `${name.slice(0, 10)}...`;
      else return name;
    },
    select(productId) {
      if (!this.readonly) {
        this.products.forEach(o => {
          if (o.id == productId) {
            if (o.selected) {
              o.selected = !o.selected;
            } else {
              o.selected = true;
            }
          }
        });

        this.$emit(
          "selected",
          this.productSolutionId,
          this.products.filter(x => x.selected != undefined)
        );
        this.$forceUpdate();
        this.$store.state.hasChanges = true;
      }
    }
  },
  created() {
    this.loading = true;
    this.getProducts(true);
  }
};
</script>


<style scoped>
.rounded {
  border-radius: 10px;
}
.border {
  border: 1px solid gainsboro;
}
.myContainer {
  white-space: nowrap;
  display: -webkit-flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  overflow-y: scroll;
  width: auto;
}
::-webkit-scrollbar {
  display: none;
}
.myColumn {
  margin: 20px;
  flex: 1 1 auto;
  /* min-width: 300px; */
  min-width: 150px;
}

.scroll-container {
  display: flex;
  overflow: auto;
  flex: none;
}
.scroll-container > div {
  text-align: center;
  scroll-snap-align: center;
  flex: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Products.vue